import { ErrorPageProps } from 'shared/domain/error-page';

import { forgetImpersonation } from 'app/autentication/store/impersonation.actions';
import { GlobalDispatch } from 'context';
import { ModalDialogueProps } from 'shared/components/ModalDialogue/ModalDialogue';
import { StatusCode } from 'shared/domain/status-code';
import { GlobalAction } from 'store/global-actions';
import { ErrorDelivery, ErrorDeliveryTarget } from '../error-delivery';
import { navigate } from '../navigate';
import { clearSessionToken } from '../session-token';
import { createFlowEndingInterceptor } from './interceptor';

const SESSION_ENDED_MESSAGE = 'Inicia sesión nuevamente para continuar.';

export const httpInterceptor = createFlowEndingInterceptor(async (response, intercept, next) => {
  if (response.ok) return next();

  const { status } = response;
  const { code, message } = await response.json();

  const isForbidden = status === StatusCode.Forbidden;

  switch (status) {
    case StatusCode.BadRequest:
    case StatusCode.NotFound:
    case StatusCode.Forbidden:
    case StatusCode.InternalServerError:
      intercept(
        ErrorDelivery.from<ErrorPageProps>(
          {
            primaryText: 'Recargar',
            primaryAction: () => (dispatch: GlobalDispatch) => {
              dispatch({ type: GlobalAction.ClearState });
            },
            code,
            title: isForbidden ? 'Acceso denegado' : undefined,
            message: isForbidden ? message : undefined,
          },
          ErrorDeliveryTarget.Page,
        ),
      );
      break;
    case StatusCode.Unauthorized:
      intercept(
        ErrorDelivery.from<ModalDialogueProps>(
          {
            isVisible: true,
            title: 'Tu sesión terminó',
            primaryButtonLabel: 'Iniciar sesión',
            primaryIcon: 'fa-sign-in',
            primaryAction: (dispatch: GlobalDispatch) => {
              dispatch({ type: GlobalAction.SetModalAlert, payload: null });
              clearSessionToken();
              forgetImpersonation();
              dispatch({ type: GlobalAction.ClearState });
              navigate('/login');
            },
            children: SESSION_ENDED_MESSAGE,
          },
          ErrorDeliveryTarget.ModalAlert,
        ),
      );
      break;
    default:
      next();
  }
});
